// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const VERSION = 'v3.0.020';
export enum StageIds {
  STAGE_INSCRICAO = "6787f36de510835c7932e88c",
  STAGE_UM_AVALIACAO = "6787f39ee510835c7932e8a2",
  STAGE_DOIS_AVALIACAO = "6787f3e3e510835c7932e8c3",
  STAGE_TRES_AVALIACAO_DIRETOR = "6787f40ee510835c7932e8d4",
  STAGE_GANHADORES_ETAPA_2 = "67ee5e609a0db36354b6066c",
  STAGE_ENTREGA = "6787f43ce510835c7932e8e1",
  STAGE_AGUARDANDO_RESULTADO = "aguardando_resultado",
}

/**
 * ControlDate IDs for phase management.
 * These match the _id field from the controle_datas__c collection.
 */
export const PHASE_IDS = {
  // ELBB phases
  ELBB_PRE_REGISTRATION: 'etapa_pre_elbb',
  ELBB_REGISTRATION_PERIOD: 'periodo_cadastro_elbb',
  ELBB_CONFIRMATION: 'confirmacao_inscricao_elbb',
  ELBB_INSCRIPTION: 'etapa_inscricao_elbb',
  ELBB_VOTING_STAGE1: '69d952080af3a52b4404f88c',
  // Conexao phases
  CONEXAO_PRE_REGISTRATION: 'etapa_pre_conexao',
  CONEXAO_REGISTRATION_PERIOD: 'periodo_cadastro_conexao',
  CONEXAO_MANAGER_APPROVAL: 'aprovacao_gestor_conexao',
  CONEXAO_CONFIRMATION: 'confirmacao_inscricao_conexao',
  // ELBB tenant: _id real do documento controle_datas__c
  ETAPA_2_PREMIO: '69d952660af3a52b4404f962',
  ETAPA_3_PREMIO: 'etapa_tres_premio',
} as const;

export type PhaseId = typeof PHASE_IDS[keyof typeof PHASE_IDS];